module.exports = __webpack_public_path__ + "img/cursor.9d718c3e.svg";